module.exports = __webpack_public_path__ + "zvetseni-prsou_37_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zvetseni-prsou_37_after_tn.jpg
// module id = 1797
// module chunks = 0